import React from 'react'
import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close'
import NavButton from './NavButton';
import NavSearch from './NavSearch';

function MobileNav({ mobileNav, setMobileNav }) {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const isToken = useSelector((state) => state.auth.isToken);

  const NavClass = () => {
    setMobileNav(!mobileNav)
  }

  return (
    <div
      className={`mobile-nav ${mobileNav ? "slide-in-left" : "slide-out-left"}`}
    >
      <div className="mobile-nav__links">
        <div
          role="button"
          tabIndex="0"
          onClick={() => NavClass()}
          onKeyDown={() => NavClass()}
          className="toggle__button"
        >
          <CloseIcon fontSize="large" />
        </div>

        <NavLink to="/coming-soon" activeClassName="active">
          Features
                </NavLink>


        <NavLink to="/about" activeClassName="active">
          About
                </NavLink>

        <NavLink to="/coming-soon" activeClassName="active">
          Contact
                </NavLink>
        <div className="mobile-nav__button">
          {
            isAuthenticated && isToken ? <NavSearch /> : <NavButton />
          }

        </div>
      </div>
    </div>

  )
}

export default MobileNav;